import { useTranslation } from 'react-i18next';

import { ContentBlock } from '~/components/molecules/ContentBlock';
import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { useLiveStreamQuery } from '~/lib/api/modules/LiveStreams/hooks/useLiveStreamQuery';
import { LiveStreamBroadcasting } from './LiveStreamBroadcasting';
import { LiveStreamInfo } from './LiveStreamInfo';
import { LiveStreamRecordingList } from './LiveStreamRecordingList';
import { LiveStreamStreaming } from './LiveStreamStreaming';

export type ILiveStreamProps = {
  appId: string;
  liveStreamId: string;
};

export const LiveStream: React.FC<ILiveStreamProps> = (props) => {
  const { appId, liveStreamId } = props;
  const liveStreamQuery = useLiveStreamQuery({
    appId,
    liveStreamId,
  });
  const { t } = useTranslation();

  const liveStream = liveStreamQuery.data;
  const ended = !!liveStream?.expired;

  return (
    <>
      {liveStreamQuery.isError ? (
        <ContentBlock>
          <ContentBlock.Body first>
            <ErrorMessage error={liveStreamQuery.error} />
          </ContentBlock.Body>
        </ContentBlock>
      ) : liveStreamQuery.isLoading ? (
        <ContentBlock>
          <ContentBlock.Body first>
            {/* TODO: use skeletons */}
            {t('common.loading')}
          </ContentBlock.Body>
        </ContentBlock>
      ) : (
        liveStream && (
          <>
            <LiveStreamInfo liveStream={liveStream} />
            {!ended && (
              <>
                <LiveStreamStreaming liveStream={liveStream} />
                <LiveStreamBroadcasting liveStream={liveStream} />
              </>
            )}
            <LiveStreamRecordingList liveStream={liveStream} />
          </>
        )
      )}
    </>
  );
};
